import type { Announcement } from "@excalidraw-ms/shared";

/**
 * The announcement feed.
 *
 * Statically bundled rather than backend-served: announcements are release
 * notes, so they are already coupled to a deploy, and a backend feed would be
 * invisible to Local-Only users - exactly the readers a capability announcement
 * most needs to reach. See docs/designs/message-taxonomy.md § 5.2.
 *
 * Announcements must not carry a call to action (§ 5.3.1), and their copy must
 * read correctly for someone who cannot use the feature yet, so it describes
 * what the product does rather than what the reader owns.
 */
export const ANNOUNCEMENTS: Announcement[] = [
  {
    id: "cloud-storage-ga-2026-08",
    title: "Cloud storage is now generally available",
    body:
      "Excalidraw-MS can now save drawings to the cloud and reopen them from Home, " +
      "share a saved drawing with specific people, and collaborate live on the same file.",
    publishedAt: "2026-08-09T00:00:00Z",
    expiresAt: "2026-10-09T00:00:00Z",
    audience: "all",
  },
  {
    // No call to action by design (§ 5.3.1) — this says the capability exists;
    // "Create with AI" owns the how. Copy is written for a
    // reader who has connected nothing yet, so it describes the product rather
    // than what the reader has.
    id: "ai-assistants-2026-08",
    title: "AI assistants can now work on Excalidraw-MS drawings",
    body:
      "Excalidraw-MS connects to AI assistants such as GitHub Copilot. An assistant given a " +
      "drawing can read it and make changes, doing exactly what the person who shared it can do " +
      "and nothing more. Setup lives under Create with AI in the toolbar and main menu. " +
      "In local-only mode, Get full access is available in the account section first.",
    publishedAt: "2026-08-18T00:00:00Z",
    expiresAt: "2026-10-18T00:00:00Z",
    audience: "all",
  },
];
